var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomQuestion = function SvgCustomQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.202 1.5 1.5 6.202 1.5 12S6.202 22.5 12 22.5 22.5 17.798 22.5 12 17.798 1.5 12 1.5Zm0 16.594a.937.937 0 1 1 0-1.875.937.937 0 0 1 0 1.875Zm1.474-5.145A1.133 1.133 0 0 0 12.75 14v.532a.188.188 0 0 1-.188.188h-1.124a.188.188 0 0 1-.188-.188v-.504a2.62 2.62 0 0 1 1.688-2.48c.796-.306 1.312-.974 1.312-1.703 0-1.034-1.01-1.875-2.25-1.875s-2.25.841-2.25 1.875v.178a.188.188 0 0 1-.188.187H8.438a.188.188 0 0 1-.188-.187v-.178c0-.921.403-1.781 1.134-2.421.704-.617 1.632-.954 2.616-.954.984 0 1.912.34 2.616.954.73.64 1.134 1.5 1.134 2.42 0 1.355-.893 2.574-2.276 3.106Z",
    fill: "currentColor"
  })));
};

export default SvgCustomQuestion;